export const stringifyError = function (error: any) {
  if (typeof error === 'string') {
    return error;
  }

  if (Object.keys(error).length < 10) {
    console.log(Object.keys(error));

    return Object.keys(error).reduce((str, v) => str + ' ' + (v + ': ' + error[v]), '');
  }

  return JSON.stringify(error);
};
